import React from "react";
export var UploadImageIcon = function UploadImageIcon() {
  return /*#__PURE__*/React.createElement("svg", {
    width: "18",
    height: "18",
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 4.77783C1 3.67326 1.89543 2.77783 3 2.77783H15C16.1046 2.77783 17 3.67326 17 4.77783V13.2223C17 14.3268 16.1046 15.2223 15 15.2223H3C1.89543 15.2223 1 14.3268 1 13.2223V4.77783ZM2.33333 9.94286V13.2223C2.33333 13.5905 2.63181 13.8889 3 13.8889H15C15.3682 13.8889 15.6667 13.5905 15.6667 13.2223V10.8318L13.6936 8.85871C13.4333 8.59836 13.0112 8.59836 12.7508 8.85871L11.0539 10.5556L11.4714 10.9731C11.7318 11.2334 11.7318 11.6556 11.4714 11.9159C11.2111 12.1763 10.7889 12.1763 10.5286 11.9159L5.91585 7.30316C5.6555 7.04281 5.23339 7.04281 4.97304 7.30316L2.33333 9.94286ZM10.7778 6.33339C10.7778 6.82431 10.3798 7.22228 9.88889 7.22228C9.39797 7.22228 9 6.82431 9 6.33339C9 5.84247 9.39797 5.4445 9.88889 5.4445C10.3798 5.4445 10.7778 5.84247 10.7778 6.33339Z",
    fill: "#6B7280"
  }));
};